import instance from '../index';
import { isOverseasEnv } from '@/utils/api';
import { instance as apiInstance } from '@/apis/index';
import { common, login, search, reportManage, securityAuth } from '../interface';
import { COMEINURL } from '../host';
export { globalSearchRequest, todayDocCount } from './globalSearch';

// 获取区号
export const getAreaCode = async () => {
  return instance.post(common.areaCode);
};

// 根据ip获取手机号归属地
export const getPhoneArea = async () => {
  return instance.post(common.getPhoneArea);
};

// 获取二维码
export const getQrCodeUrl = async (data) => {
  return instance.post(login.qrcodelogin, data);
};

// 退出登录
export const loginOut = async (data, config) => {
  return instance.post(login.weblogout, data, config);
};

// 帐号密码登录
export const accountLogin = async (data, config) => {
  return instance.post(login.weblogin, data, config);
};

// 帐号密码登录
export const phoneLogin = async (data, config) => {
  return instance.post(login.phonelogin, data, config);
};

// 取消注销申请
export const cancelApply = async (data, config) => {
  return instance.post(login.cancelApply, data, config);
};

// 获取机构列表
export const getUserOrgList = async (data) => {
  return instance.get(login.orgList, data);
};

// 选择机构
export const selectOrg = async (data, config) => {
  return instance.post(login.switchIdentity, data, config);
};

// 发送手机验证码
export const sendPhoneCode = async (data, config) => {
  return instance.post(login.getPhoneCode, data, config);
};

// 发送邮箱验证码/邮箱验证码登录
export const getemailauth = async (data, config) => {
  return instance.post(login.getemailauth, data, config);
};

// 腾讯滑块验证码
export const fetchTencentCaptcha = async (data) => {
  return instance.get(common.phpUrl, data);
};

// 校验token是否有效
export const checkToken = async (data, config) => {
  return instance.post(login.userquery, data, config);
};

// 获取用户详情（含 complianceRestricted：是否合规受限用户 1=是/0=否）
export const getUserDetail = async (data, config) => {
  return instance.get(login.getUserDetail, data, config);
};

// 合规受限用户超时退出登录
export const complianceLogout = async (data, config) => {
  return instance.get(login.complianceLogout, data, config);
};

// 查询会员权益
export const checkMemberBenefit = async (data) => {
  return instance.post(login.checkMemberBenefit, data);
};

// 查询用户开通会员信息
export const queryUserMembership = async (data) => {
  return await instance.post(login.queryUserMembership, data);
};

// 更新邮箱密码
export const findPwdByEmail = async (data, config) => {
  return instance.post(login.findPwdByEmail, data, config);
};

// 校验手机验证码
export const checkPhoneCode = async (data, config) => {
  return instance.post(login.checkPhoneCode, data, config);
};

// 账号重置密码（通过手机号）
export const resetPwd = async (data, config) => {
  return instance.post(login.resetPwd, data, config);
};

// 获取邀请通知列表
export const getInviteList = async (data, config) => {
  return instance.post(login.invite, data, config);
};

// 或略邀请通知
export const ignoreInvite = async (data, config) => {
  return instance.post(login.ignoreInvite, data, config);
};

// 通过邀请通知
export const acceptInvite = async (data, config) => {
  return instance.post(login.acceptInvite, data, config);
};

// 热门搜索
export const getHotSearch = async (data) => {
  return instance.post(search.hotSearch, data);
};

// 热门搜索placeholder
export const getHotSearchPlaceholder = async (data) => {
  return instance.post(search.hotSearchPlaceholder, data);
};

// 改版后的热门搜索
export const hotSearchCollect = async (data) => {
  return instance.post(common.hotSearchCollect, data);
};

// 搜索词联想
export const getWordHints = async (data) => {
  return instance.post(search.searchCompletionHints, data);
};

// 获取分词
export const getWordSegment = async (data) => {
  return instance.post(search.wordSegment, data);
};

// 获取分词-new
export const getWordSegmentNew = async (data) => {
  return instance.post(search.wordSegmentNew, data);
};

// 全局搜索研报
export const searchReport = async (data) => {
  return instance.post(search.reportSearch, data);
};

// 全局搜索路演
export const searchRoadshow = async (data) => {
  return instance.post(search.roadshowSearch, data);
};

// 获取搜索结果高亮
export const getHighlight = async (data) => {
  return instance.post(search.highlight, data);
};

// 全局搜索 纪要列表
export const getSearchSummary = async (data) => {
  return instance.post(search.summarySearch, data);
};

// 全局搜索 获取资源下载
export const getDownload = async (data) => {
  return instance.post(search.download, data);
};

// 全局搜索 获取资源链接相关信息
export const getDocumentInfo = async (data) => {
  return instance.post(search.getDocumentInfo, data);
};

// 全局搜索 获取搜索配置
export const getQuerySettingByType = async (params) => {
  return instance.post(search.getQuerySetting, {}, { params });
};

// 全局搜索 保存搜索配置
export const saveQuerySetting = async (data) => {
  return instance.post(search.saveQuerySetting, data);
};

// 筛选组件 获取人员列表
export const getPersonList = async (data) => {
  return instance.post(common.personList, data);
};

// 路演列表
export const getRoadshowList = async (data) => {
  return instance.post(common.roadshowList, data);
};

// 路演 添加ai会记
export const addRoadshowAinote = async (data, option) => {
  return instance.post(common.roadshowAinote, data, option);
};

// 路演 ai会记确认提示
export const getRoadshowAinoteConfirm = async (data, option) => {
  return instance.post(common.roadshowAinoteConfirm, data, option);
};

// 调研列表
export const getSurveyList = async (data) => {
  return instance.post(common.researchActivityList, data);
};

// 研报
export const getReportList = async (data) => {
  return instance.post(common.reportList, data);
};

// 观点列表
export const getViewpointist = async (data) => {
  return instance.post(reportManage.getViewpointList, data);
};

//点评列表
export const getInsightsList = async (data, config = {}) => {
  return instance.post(reportManage.getInsightsList, data, config);
};

// 全部列表
export const getAllList = async (data, config = {}) => {
  return instance.post(reportManage.getAllList, data, config);
};

// 纪要
export const getSummaryList = async (data) => {
  return instance.post(common.summaryList, data);
};

// 查询企业下的服务专员
export const orgCustomerService = async (data) => {
  return instance.post(common.orgCustomerService, data);
};

// 上传文件（阿里云）
export const uploadFile = async (data, config = {}) => {
  return await instance.post(common.upload, data, config);
};

// 分片上传
export const chunkUpload = async (data) => {
  return await instance.post(common.chunkUpload, data);
};

// 阿里云中转，搭配 uploadFile
export const ossFileToUpload = async (host, data, config = { bodyType: 'file' }) => {
  return await instance.post(host, data, config);
};

/** OSS：获取指定目录下直接子文件与子文件夹（走 /comein/json_oss_file-list，避免短链被解析到 /aiChat/） */
export const getOssFileList = async (data, config = {}) => {
  return await instance.post(common.ossFileList, data, config);
};

/** OSS：获取指定对象的 GET 预签名 URL（/json/oss/file-presigned-url） */
export const getOssFilePresignedUrl = async (data, config = {}) => {
  return await instance.post(common.ossFilePresignedUrl, data, config);
};

/** OSS：文件复制（/json/oss/file-copy） */
export const ossFileCopy = async (data, config = {}) => {
  return await instance.post(common.ossFileCopy, data, config);
};

// 用户安全认证 - 发送验证码
export const sendSecurityCode = async (data, config = {}) => {
  return await instance.post(securityAuth.sendSecurityCode, data, config);
};

// 用户安全认证 - 验证码验证
export const checkSecurityCode = async (data, config = {}) => {
  return await instance.post(securityAuth.checkSecurityCode, data, config);
};

// 获取机构logo
export const getOrganizationLogo = async (data, config) => {
  return await instance.get(common.orgLogo, data, config);
};

export const bindEmail = async (data, config) => {
  return await instance.post(login.bindEmail, data, config);
};

// 配置
export const commonConfig = async (data) => {
  return await instance.get(common.commonConfig, data);
};
// 用户关注或取消关注行业
export const industryOperation = async (data) => {
  return await instance.post(common.industryOperation, data);
};

// 获取反馈类型列表
export const getFeedbackTypeList = async (data) => {
  return await instance.post(common.feedbackTypeList, data);
};
// 获取反馈
export const feedbackSubmit = async (data) => {
  return await instance.post(common.feedbackSubmit, data);
};

// 筛选条件
export const getNewFilterConfigList = async (data, config = {}) => {
  return await instance.post(common.getNewFilterConfigList, data, config);
};

// 会员试用领取条件
export const getMemberShipFreeActivity = async (data, config = {}) => {
  return await instance.get(common.getMemberShipFreeActivity, data, config);
};

// 会员试用-不再提醒
export const setMemberRemind = async (data, config = {}) => {
  return await instance.get(common.setMemberRemind, data, config);
};

// 会员试用-领取试用
export const receiveMemberTryout = async (data, config = {}) => {
  return await instance.get(common.receiveMemberTryout, data, config);
};

// 会员试用-问卷
export const sumbitQuestion = async (data, config = {}) => {
  return await instance.post(common.sumbitQuestion, data, config);
};

export const uploadLogAction = async (data, config = {}) => {
  return await instance.post(common.uploadLog, data, config);
};
/**
 * 获取一级行业
 */
export const getTierOneIndustries = async (data, config = {}) => {
  try {
    const result = await instance.post(common.tierOneIndustries, data, config);
    if (!result?.data) {
      throw new Error('result.data 为空');
    }

    return result.data;
  } catch (error) {
    console.error('获取热点列表失败', error);
  }
};

// 用户习惯相关
export const saveUserPreference = async (data, config = {}) => {
  return await instance.post(common.saveUserPreference, data, config);
};

export const getUserPreferenceList = async (data, config = {}) => {
  return await instance.post(common.getUserPreferenceList, data, config);
};

// 搜索补全接口
export const querySearchCompletionHints = async (data, config = {}) => {
  return await instance.post(search.searchCompletionHints, data, config);
};

// 保存成员交互
export const saveInteraction = async (data, config) => {
  return await instance.post(common.saveInteraction, data, config);
};

// 获取公共配置
export const getCommonConfig = async (data, config) => {
  return await instance.get(common.getCommonConfig, data, config);
};

// 获取浏览记录
export const getUserBrowse = async (data, config) => {
  if (isOverseasEnv()) {
    return await apiInstance.post('/user/browse/get-user-browse', data, config);
  }
  return await instance.post(common.getUserBrowse, data, config);
};

/** 查询当前用户今日是否需要弹窗，成功时返回体含 data.needShow */
export const checkPopupNeedShow = async (params, config = {}) => {
  return await instance.get(common.popupCheck, params, config);
};

/** 记录当前用户今日已弹窗（POST，body 含 type 等） */
export const recordPopupShown = async (data, config = {}) => {
  return await instance.post(common.popupRecord, data, config);
};

// 获取最新版本
export const versionLastVersion = async (data, config) => {
  return await instance.get(common.versionLastVersion, data, config);
};

// 版本更新已读上报
export const versionAddUserBrowse = async (data, config) => {
  return await instance.post(common.versionAddUserBrowse, data, config);
};

// 试用会员弹窗
export const getMemberDaysInfo = async (data, options) => {
  return await instance.get(common.freeactivityWindow, data, options);
};

// 试用会员弹窗-问题列表
export const freeactivityQueryQuestion = async (data, options) => {
  return await instance.post(common.freeactivityQueryQuestion, data, options);
};

// BRM嵌入SRS工作台
export const getSrsWorkbench = async (data, config = {}) => {
  return await instance.post(common.getSrsWorkbench, data, config);
};

// 获取IRM token
export const getIrmToken = async (data, config = {}) => {
  return await instance.get(`${COMEINURL}/${common.getIrmToken}`, data, config);
};
